import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { AdminCampaignApiItem, CampaignCreateApiRequest, CampaignParticipantApiItem, CampaignStatusToggleApiItem, CampaignUpdateApiRequest } from '../interfaces/admin-campaign.interface';
import { CampaignTypeApiItem } from '../interfaces/campaign-type.interface';

@Injectable({
  providedIn: 'root'
})
export class AdminCampaignService extends BaseApiService {
  getCampaigns(dataIni?: string, dataFim?: string, idTipoCampanha?: number): Observable<AdminCampaignApiItem[]> {
    let endpoint = '/campaign';
    const params: string[] = [];

    if (dataIni && dataFim) {
      params.push(`dataIni=${encodeURIComponent(dataIni)}`);
      params.push(`dataFim=${encodeURIComponent(dataFim)}`);
    }

    if (idTipoCampanha) {
      params.push(`idTipoCampanha=${idTipoCampanha}`);
    }

    if (params.length > 0) {
      endpoint += `?${params.join('&')}`;
    }

    return this.get<AdminCampaignApiItem[]>(endpoint);
  }

  getCampaignTypes(): Observable<CampaignTypeApiItem[]> {
    return this.get<CampaignTypeApiItem[]>('/campaign/types');
  }

  downloadCampaignTemplate(): Observable<HttpResponse<Blob>> {
    return this.getHttpClient().get(`${this.getBaseUrl()}/campaign/template`, {
      headers: this.getAuthHeaders(false),
      responseType: 'blob',
      observe: 'response'
    });
  }

  getCampaignParticipants(campaignCode: string): Observable<CampaignParticipantApiItem[]> {
    return this.get<CampaignParticipantApiItem[]>(`/campaign/${encodeURIComponent(campaignCode)}/participants`);
  }

  toggleCampaignStatus(idCampanha: number): Observable<CampaignStatusToggleApiItem> {
    return this.post<CampaignStatusToggleApiItem>(`/campaign/${idCampanha}/toggle-status`);
  }

  updateCampaign(payload: CampaignUpdateApiRequest): Observable<AdminCampaignApiItem> {
    return this.put<AdminCampaignApiItem>('/campaign', payload);
  }

  createCampaign(payload: CampaignCreateApiRequest): Observable<AdminCampaignApiItem> {
    const formData = new FormData();
    formData.append('cdCampanha', payload.cdCampanha);
    formData.append('idTipoCampanha', String(payload.idTipoCampanha));
    formData.append('nmCampanha', payload.nmCampanha);
    formData.append('dtIni', payload.dtIni);
    formData.append('dtFim', payload.dtFim);
    formData.append('flStatus', payload.flStatus);
    formData.append('arquivoLeads', payload.arquivoLeads, payload.arquivoLeads.name);

    return this.post<AdminCampaignApiItem>('/campaign', formData, false);
  }
}